import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";
import { useApp } from "../context/AppContext";
import { Wine, Home as HomeIcon, ShoppingBag } from "lucide-react";

export default function NotFound() {
  const { lang } = useApp();
  const de = lang === "de";
  return (
    <div className="pt-40 pb-28 bg-cream min-h-screen text-center px-6" data-testid="not-found-page">
      <Seo title={de ? "Seite nicht gefunden (404)" : "Page not found (404)"} description={de ? "Diese Seite existiert nicht mehr." : "This page no longer exists."} lang={lang} noindex />
      <Wine className="w-14 h-14 text-wine mx-auto mb-6" />
      <p className="font-serif text-7xl text-wine/25">404</p>
      <h1 className="font-serif text-3xl md:text-4xl text-ink mt-4">{de ? "Diese Seite gibt es nicht (mehr)." : "This page doesn't exist (anymore)."}</h1>
      <p className="mt-4 text-ink/60 text-lg max-w-xl mx-auto">
        {de ? "Vielleicht wurde sie beim Relaunch umbenannt. Hier geht's zurück zu den guten Tropfen:" : "It may have been renamed during our relaunch. Back to the good stuff:"}
      </p>
      <div className="mt-9 flex flex-wrap justify-center gap-4">
        <Link to="/"><Button data-testid="notfound-home-btn" className="bg-wine hover:bg-wine-dark text-white h-12 px-8 rounded-full gap-2"><HomeIcon className="w-4 h-4" /> {de ? "Zur Startseite" : "Go home"}</Button></Link>
        <Link to="/store"><Button data-testid="notfound-store-btn" variant="outline" className="rounded-full border-ink/20 text-ink hover:bg-ink hover:text-cream h-12 px-8 gap-2"><ShoppingBag className="w-4 h-4" /> {de ? "Zum Shop" : "Visit the store"}</Button></Link>
      </div>
    </div>
  );
}
